// Tenant co-branding limits (PRD-55 §FR-2).
//
// MIRRORS apps/backend/core/constants.py::BrandingConfig. The backend is
// canonical (magic-values.md §1); this copy exists only to give the
// director a fast, friendly rejection instead of a round-trip. When you
// change one side, change the other in the SAME PR.
//
// The drift this convention exists to prevent already happened once on
// the student portal, where `text/plain` silently diverged between the
// two mirrors — so treat a mismatch here as a bug, not a nuance.

export const BRANDING_ACCEPTED_MIME = ["image/png", "image/webp"] as const

// SVG is deliberately absent, on both sides. It is an executable document
// (script elements, foreignObject, external entity refs), so accepting it
// would mean owning an XSS sanitizer for a format built to defeat
// sanitizers. Do not add it here without an ADR.
export const BRANDING_ACCEPT_ATTRIBUTE = BRANDING_ACCEPTED_MIME.join(",")

/** 256 KB. Every byte is served on the professor's first paint. */
export const BRANDING_MAX_BYTES = 256 * 1024

/** Shown in the hint, so the director knows the bar before picking a file. */
export const BRANDING_MAX_KB = BRANDING_MAX_BYTES / 1024
